import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Welcome from '../Welcome/Welcome';
import Movies from '../Movies/Movies';
import Article from '../Article/Article';
import { interstitial } from '../Services/Adsense/ads';

export default class App extends Component {
  componentDidMount() {
    interstitial()

  }

  render() {
    return (
      <Router>
        <div className={`App`} >
          <Header />
          <Switch>
            <Route path="/" exact component={Movies} />
            <Route path="/article/:id" exact component={Article} />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx